import { createFileRoute } from "@tanstack/react-router";
import BenefitsOfPsychotherapyForAnxietyAndDepressionPage from "@/pages/articles/BenefitsOfPsychotherapyForAnxietyAndDepressionPage";
export const Route = createFileRoute(
  "/the-benefits-of-psychotherapy-for-managing-anxiety-and-depression",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Psychotherapy for Anxiety & Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "The benefits of psychotherapy for anxiety and depression. Learn how therapy complements TMS and medication at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content:
            "Psychotherapy for Anxiety & Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "The benefits of psychotherapy for anxiety and depression. Learn how therapy complements TMS and medication at Neuro Wellness TMS in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/the-benefits-of-psychotherapy-for-managing-anxiety-and-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/the-benefits-of-psychotherapy-for-managing-anxiety-and-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BenefitsOfPsychotherapyForAnxietyAndDepressionPage />;
}
